import React from 'react';

class Roletab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render = () => <div>TODO: criar essa aba de cargos</div>;
}

export default Roletab;
